// Shared formatters + the client-side CSV export for the Funnel tab. (The
// recharts atoms that lived here went with the old charts on 2026-10-25;
// charts now come from ../teams/teamCharts.js, source colors from
// ./sourceGroups.js.)
import { mkConfig, generateCsv, download } from 'export-to-csv';

export const fmtNumber = (v) => Number(v || 0).toLocaleString('en-US');

export const fmtCurrency = (v) =>
  `$${Number(v || 0).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;

// Client-side CSV download (same export-to-csv recipe as ClaimsManagerMetrics).
// Nulls are blanked so the generated CSV opens clean in Excel.
// Formula-injection guard (QA 2026-08-26): lead names/emails are written by
// anonymous public forms, and Excel executes cells starting with = + - @ as
// formulas even inside quoted CSV - neutralize with a leading apostrophe
// (same rule as src/lib/csv.js csvEscape; export-to-csv handles quoting).
const neutralizeFormula = (v) => {
  if (typeof v !== 'string') return v;
  return /^[=+\-@]/.test(v) ? `'${v}` : v;
};

export const exportRowsToCsv = (filename, rows) => {
  if (!rows || !rows.length) return;
  const clean = rows.map((r) =>
    Object.fromEntries(
      Object.entries(r).map(([k, v]) => [
        k,
        v == null ? '' : neutralizeFormula(v),
      ]),
    ),
  );
  const csvConfig = mkConfig({ filename, useKeysAsHeaders: true });
  download(csvConfig)(generateCsv(csvConfig)(clean));
};
